import './styles/cart.scss';

import './cart.js';
import './services/cartService.js';
import './directives/cartDirectives.ts';

import './controllers/cartAddController.js';
import './controllers/cartConfirmController.js';
import './controllers/cartCountController.js';
import './controllers/cartFullController.js';
import './controllers/cartMiniController.js';
import './controllers/cartMiniListController.js';
import './controllers/cartMiniTypes/cartMiniPopupController.js';
import './controllers/cartMobileFullController.js';
import './controllers/cartFullItemsController.ts';
import './controllers/cartFullSummaryController.ts';
import './styles/cart-full-product.scss';
import './styles/cart-full-summary.scss';

export default 'cart';
